import axios from "axios";
import { getInstance } from "../auth/index.js";

export async function searchUsers(search = "", page = 1, pageSize = 50) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_USER_SEARCH;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const params = {
    page,
    page_size: pageSize
  };

  if (search && search.trim()) {
    params.search = search.trim();
  }

  try {
    const response = await axios.get(endpoint, { headers, params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getAllSearches(search = "", page = 1, pageSize = 50, filters = {}) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_SEARCHES;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const params = {
    page,
    page_size: pageSize
  };

  if (search && search.trim()) {
    params.search = search.trim();
  }

  const {
    full_name,
    email,
    plain_text_query,
    run_date_from,
    run_date_to
  } = filters;

  if (full_name && full_name.trim()) {
    params.full_name = full_name.trim();
  }

  if (email && email.trim()) {
    params.email = email.trim();
  }

  if (plain_text_query && plain_text_query.trim()) {
    params.plain_text_query = plain_text_query.trim();
  }

  if (run_date_from && String(run_date_from).trim()) {
    params.run_date_from = String(run_date_from).trim();
  }

  if (run_date_to && String(run_date_to).trim()) {
    params.run_date_to = String(run_date_to).trim();
  }

  try {
    const response = await axios.get(endpoint, { headers, params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getAllUserHistory(search = "", page = 1, pageSize = 50, filters = {}) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_USER_HISTORY;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const params = {
    page,
    page_size: pageSize
  };

  if (search && search.trim()) {
    params.search = search.trim();
  }

  const {
    full_name,
    email,
    url,
    path,
    route_name,
    description,
    created_from,
    created_to
  } = filters;

  if (full_name && full_name.trim()) {
    params.full_name = full_name.trim();
  }

  if (email && email.trim()) {
    params.email = email.trim();
  }

  if (url && url.trim()) {
    params.url = url.trim();
  }

  if (path && path.trim()) {
    params.path = path.trim();
  }

  if (route_name && route_name.trim()) {
    params.route_name = route_name.trim();
  }

  if (description && description.trim()) {
    params.description = description.trim();
  }

  if (created_from && String(created_from).trim()) {
    params.created_from = String(created_from).trim();
  }

  if (created_to && String(created_to).trim()) {
    params.created_to = String(created_to).trim();
  }

  try {
    const response = await axios.get(endpoint, { headers, params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getSearchStatsByUser(search = "", page = 1, pageSize = 50, filters = {}) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_SEARCH_STATS;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const params = {
    page,
    page_size: pageSize
  };

  if (search && search.trim()) {
    params.search = search.trim();
  }

  const {
    full_name,
    email
  } = filters;

  if (full_name && full_name.trim()) {
    params.full_name = full_name.trim();
  }

  if (email && email.trim()) {
    params.email = email.trim();
  }

  try {
    const response = await axios.get(endpoint, { headers, params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserStoryboards(userId) {
  if (!userId) {
    return Promise.reject(new Error("Either userId"));
  }

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_STORYBOARDS;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const params = {};
  params.user_id = userId;

  try {
    const response = await axios.get(endpoint, { headers, params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function copyStoryboard(storyboardId, targetUserId) {
  if (!storyboardId || !targetUserId) {
    return Promise.reject(
      new Error("storyboard_id and target_user_id are required")
    );
  }

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_COPY_STORYBOARD;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };

  const data = {
    storyboard_id: storyboardId,
    target_user_id: targetUserId
  };

  try {
    const response = await axios.post(endpoint, data, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserSavedSearches(userId) {
  if (!userId) {
    return Promise.reject(new Error("Either userId"));
  }

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_SAVED_SEARCHES;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const params = {};
  params.user_id = userId;

  try {
    const response = await axios.get(endpoint, { headers, params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function copySavedSearch(searchId, targetUserId) {
  if (!searchId || !targetUserId) {
    return Promise.reject(
      new Error("search_id and target_user_id are required")
    );
  }

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_COPY_SAVED_SEARCH;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };

  const data = {
    search_id: searchId,
    target_user_id: targetUserId
  };

  try {
    const response = await axios.post(endpoint, data, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getAllAIConversationThreads(search = "", page = 1, pageSize = 50, filters = {}) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_AI_CONVERSATION_THREADS;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const params = {
    page,
    page_size: pageSize
  };

  if (search && search.trim()) {
    params.search = search.trim();
  }

  const {
    full_name,
    email,
    title,
    status,
    created_from,
    created_to,
    updated_from,
    updated_to
  } = filters;

  if (full_name && full_name.trim()) {
    params.full_name = full_name.trim();
  }

  if (email && email.trim()) {
    params.email = email.trim();
  }

  if (title && title.trim()) {
    params.title = title.trim();
  }

  if (status && status.trim()) {
    params.status = status.trim();
  }

  if (created_from && String(created_from).trim()) {
    params.created_from = String(created_from).trim();
  }

  if (created_to && String(created_to).trim()) {
    params.created_to = String(created_to).trim();
  }

  if (updated_from && String(updated_from).trim()) {
    params.updated_from = String(updated_from).trim();
  }

  if (updated_to && String(updated_to).trim()) {
    params.updated_to = String(updated_to).trim();
  }

  try {
    const response = await axios.get(endpoint, { headers, params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getAIConversationContents(threadId, page = 1, pageSize = 50, filters = {}) {
  if (!threadId) {
    return Promise.reject(new Error("thread_id is required"));
  }

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = process.env.VUE_APP_API_ADMIN_AI_CONVERSATION_CONTENTS;
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };
  const params = {
    thread_id: threadId,
    page,
    page_size: pageSize
  };

  const {
    role,
    content_type,
    visibility,
    created_from,
    created_to
  } = filters;

  if (role && role.trim()) {
    params.role = role.trim();
  }

  if (content_type && content_type.trim()) {
    params.content_type = content_type.trim();
  }

  if (visibility && visibility.trim()) {
    params.visibility = visibility.trim();
  }

  if (created_from && String(created_from).trim()) {
    params.created_from = String(created_from).trim();
  }

  if (created_to && String(created_to).trim()) {
    params.created_to = String(created_to).trim();
  }

  try {
    const response = await axios.get(endpoint, { headers, params });
    return response.data;
  } catch (error) {
    throw error;
  }
}
